interface SpacerProps {
    minWidth?: number
}

const Spacer = (props: SpacerProps) => {
    return <div style={{flexGrow: 1, minWidth: props.minWidth}}/>
}

export {Spacer}